import { Heading, VStack } from '@chakra-ui/react'

import { SignupContainer } from '@src/components/sco/Account/SignupContainer'
import { SignupPaymentForm } from '@src/components/sco/Account/SignupPaymentForm'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { TrackEvent } from '@src/lib/TrackEvent'
import tracker from '@src/lib/tracker'
import { useRouter, useSearchParams } from 'next/navigation'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default function Page() {
  const router = useRouter()
  const params = useSearchParams()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('investor-matching.payment')
  })

  return (
    <>
      <TrackEvent
        allowDuplicates={false}
        onlyOnScreen={true}
        action={() => {
          tracker.investorOutreach.purchaseViewed()
        }}
      />
      <ScoSiteNavBar />

      <VStack align={'center'} justify={'center'} minHeight={'90vh'} paddingY={[0, 0, 0, 8]} width={'full'}>
        <SignupContainer
          productId={params.get('productId')}
          contentProps={{
            title: 'Raise Capital 10x Faster.',
            subtitle: (
              <Heading marginTop={'0.5em'} size={'md'}>
                Accelerator your fundraise with investor matching and automated outreach.
              </Heading>
            ),
          }}
        >
          <SignupPaymentForm
            allowProductChange={false}
            couponCode={params.get('couponCode')}
            paymentProvider={'stripe-methods'}
            productChangePath={`/investors/matching/plans`}
            productId={params.get('productId') || 'scom-accelerator-tools'}
            returnToHref={'/investors/matching/start'}
            showCouponForm={true}
            termId={params.get('termId')}
          />
        </SignupContainer>
      </VStack>
    </>
  )
}
